module.exports = __webpack_public_path__ + "static/media/blogs_image.43c5d411.svg";